module.exports = __webpack_public_path__ + "static/media/car-service-not-ok.de3783e0.svg";